module.exports = __webpack_public_path__ + "static/media/gb11.4627a652.png";